import { Button, AddRoundedIcon, type ButtonProps } from '@shared/components';

export default function AddQuestionButton(props: ButtonProps) {
  return (
    <Button {...props} startIcon={<AddRoundedIcon />}>
      Add Question
    </Button>
  );
}
